import { HelmetProvider } from "react-helmet-async";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.scss";
import { GlobalContext } from "./components/Global/GlobalContext/GlobalContext";
import KycFilboMobileRedirect from "./components/Kyc/KycFilboMobileRedirect/KycFilboMobileRedirect";
import KycHome from "./components/Kyc/KycHome/KycHome";
import KycLayout from "./components/Kyc/KycLayout/KycLayout";

const router = createBrowserRouter([
  {
    element: <KycLayout />,
    children: [
      {
        path: "/",
        element: <KycHome />,
      },
      {
        path: "/filbo-mobile-redirect",
        element: <KycFilboMobileRedirect />,
      },
    ],
  },
]);

function App() {
  return (
    <HelmetProvider>
      <GlobalContext>
        <RouterProvider router={router} />
      </GlobalContext>
    </HelmetProvider>
  );
}

export default App;
